import React, { useState, useEffect } from "react";

import "./SignIn.css";

import { useNavigate } from "react-router-dom";

import BackArrow from "../../images/backArrow.svg";
import ErrorIcon from "../../images/errorIcon.svg";
import SignInIcon from "../../images/signInIcon.svg";
import SignInLogin from "../../images/signInLogin.svg";
import SignInPass from "../../images/signInPass.svg";

import InfoPopup from "../InfoPopup/InfoPopup";
import { vandalAuth } from "../../utils/Auth";

function SignIn() {
  const navigate = useNavigate();

  useEffect(() => {
    vandalAuth.getUserProfile().then((data) => {
      if (data.user) {
        navigate("/admin");
      }
    });
  }, []);

  const [infoActive, setInfoActive] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [formValues, setFormValues] = useState({
    LoginInput: "",
    PasswordInput: "",
  });

  function handleChange(e) {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    vandalAuth
      .authorize(formValues.PasswordInput, formValues.LoginInput)
      .then((data) => {
        if (data.message) {
          setErrorMessage("");
          navigate("/admin");
        } else if (data.error) {
          setErrorMessage(data.error);
        }
      });
  }
  return (
    <div className="SignIn">
      <div className="signin__popup">
        <div className="signin__popup__header">
          <div className="signin__popup__header__titleCon">
            <p className="signin__popup__header__titleCon__title">
              Войдите как администратор и модерируйте
            </p>
            <p className="signin__popup__header__titleCon__subtitle">
              и снова без лишних деталей
            </p>
          </div>
          <button
            onClick={() => navigate("/main")}
            type="button"
            className="signin__popup__header__titleCon__btn"
          >
            <img alt="icon" src={BackArrow} />
            Вернуться назад
          </button>
        </div>
        <form onSubmit={handleSubmit} className="signin__popup__body">
          <label className="signin__popup__body__label">
            <img
              alt="icon"
              src={SignInLogin}
              className="signin__popup__body__img"
            />
            <input
              type="login"
              className="signin__popup__body__input"
              placeholder="Логин"
              value={formValues.LoginInput}
              onChange={handleChange}
              name="LoginInput"
            />
          </label>
          <label className="signin__popup__body__label">
            <img
              alt="icon"
              src={SignInPass}
              className="signin__popup__body__img"
            />
            <input
              type="password"
              className="signin__popup__body__input"
              placeholder="Пароль"
              value={formValues.PasswordInput}
              onChange={handleChange}
              name="PasswordInput"
            />
          </label>

          <div className="signin__popup__body__btns">
            <button
              onClick={() => {
                setInfoActive(true);
              }}
              className="signin__popup__body__btns__error"
              type="button"
            >
              <img alt="icon" src={ErrorIcon} />
              Не помню пароль
            </button>
            <p className="signin__popup__body__btn__message">{errorMessage}</p>
            <button className="signin__popup__body__btns__signin" type="submit">
              <img alt="icon" src={SignInIcon} />
              Войти как администратор
            </button>
          </div>
        </form>
        <InfoPopup open={infoActive} setOpen={setInfoActive} info={"signin"} />
      </div>
    </div>
  );
}

export default SignIn;
